import { annualSolarSavings } from '../solar/selectors';
import { getOBSITC } from '../tax/selectors';
import { getSRECs } from '../srecs/selectors';
import { getSMARTvalue } from '../smart/selectors';

export const getOBSAnnualPayment = (state, year) => {
    const { cashprice } = state.solar;
    const {
        obsDownPayment,
        obsTerm,
        obsCredit,
    } = state.obs;

    let paymentFactor = 0;
    // removed for now - Lester cannot supply less than investment grade
    // if (obsCredit === 1 && cashprice > 49999.99 && cashprice < 100000) {
    //     paymentFactor = 0.01596;
    // }
    // if (obsCredit === 1 && cashprice >= 100000 && cashprice < 250000) {
    //     paymentFactor = 0.1150;
    // }
    // if (obsCredit === 1 && cashprice >= 250000 && cashprice < 500000) {
    //     paymentFactor = 0.01085;
    // }
    if (obsCredit === 1 && cashprice >= 500000 && cashprice < 1500000) {
        paymentFactor = 0.010150;
    }
    if (obsCredit === 1 && cashprice >= 1500000 && cashprice < 3000000) {
        paymentFactor = 0.096;
    }


    const obsPrice = cashprice - obsDownPayment;

    let obsPayment = 0;

    if (year <= obsTerm / 12) {
        obsPayment = obsPrice * paymentFactor * 12;
    }

    if (cashprice < 100000 && year === 6 && obsTerm === 60) {
        obsPayment = obsPrice * 0.20;
    }
    if (cashprice < 250000 && year === 8) {
        obsPayment = obsPrice * 0.20;
    }
    if (year === 8 && cashprice >= 250000) {
        obsPayment = obsPrice * 0.20;
    }

    return obsPayment;
};

export const getOBSAnnualPaymentESS = (state, year) => {
    const { cashprice } = state.solar;
    const {
        obsDownPayment,
        obsTerm,
        obsCredit,
    } = state.obs;
    const { includeESS, essPrice } = state.ess;

    let paymentFactor = 0;
    // removed for now - Lester cannot supply less than investment grade
    // if (obsCredit === 1 && cashprice > 49999.99 && cashprice < 100000) {
    //     paymentFactor = 0.01596;
    // }
    // if (obsCredit === 1 && cashprice >= 100000 && cashprice < 250000) {
    //     paymentFactor = 0.1150;
    // }
    // if (obsCredit === 1 && cashprice >= 250000 && cashprice < 500000) {
    //     paymentFactor = 0.01085;
    // }
    if (obsCredit === 1 && cashprice >= 500000 && cashprice < 1500000) {
        paymentFactor = 0.010150;
    }
    if (obsCredit === 1 && cashprice >= 1500000 && cashprice < 3000000) {
        paymentFactor = 0.096;
    }


    let obsPrice = cashprice - obsDownPayment;
    if (includeESS === true) {
        obsPrice = cashprice + essPrice - obsDownPayment;
    }

    let obsPayment = 0;

    if (year <= obsTerm / 12) {
        obsPayment = obsPrice * paymentFactor * 12;
    }

    if (cashprice < 100000 && year === 6 && obsTerm === 60) {
        obsPayment = obsPrice * 0.20;
    }
    if (cashprice < 250000 && year === 8) {
        obsPayment = obsPrice * 0.20;
    }
    if (year === 8 && cashprice >= 250000) {
        obsPayment = obsPrice * 0.20;
    }

    return obsPayment;
};

export const getAnnualOBSSavings = (state, prevSolarValue, year) => {
    const { cashprice } = state.solar;
    const { obsDownPayment, obsTerm } = state.obs;

    let obsSavings = 0;
    const srecs = getSRECs(state);
    const smart = getSMARTvalue(state);

    const obsPrice = cashprice - obsDownPayment;

    let obsBuyout = obsPrice * 0.20;
    if (obsPrice < 250000) {
        obsBuyout = obsPrice * 0.2;
    }

    if (year === 1) {
        obsSavings =
            annualSolarSavings(year, prevSolarValue, state) +
            srecs[year] -
            getOBSAnnualPayment(state, year) +
            smart[year];
    } else if (year <= obsTerm / 12) {
        obsSavings =
            annualSolarSavings(year, prevSolarValue, state)
            + smart[year]
            + srecs[year]
            - getOBSAnnualPayment(state, year);
    } else if (year === ((obsTerm + 12) / 12)) {
        obsSavings =
            annualSolarSavings(year, prevSolarValue, state)
            + srecs[year]
            + smart[year]
            + getOBSITC(state, year)
            - obsBuyout;
    } else {
        obsSavings =
            annualSolarSavings(year, prevSolarValue, state) +
            srecs[year] +
            smart[year] -
            getOBSAnnualPayment(state, year);
    }
    return obsSavings;
};



// WEBPACK FOOTER //
// ./src/containers/common/obs/selectors.js